import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type {
	DashboardSunriseExperimentDataQuery,
	DashboardSunriseExperimentDataQueryVariables,
} from './experiments.graphql';
import { DashboardSunriseExperimentData } from './experiments.graphql';

async function queryExperiment(utilityContext: UtilityContext) {
	const {
		data: {
			experiments: { starterExperienceDashboardSunriseV1 },
		},
	} = await utilityContext.gql.fetch<DashboardSunriseExperimentDataQuery, DashboardSunriseExperimentDataQueryVariables>(
		{
			query: DashboardSunriseExperimentData,
			variables: {},
			rejectOnError: true,
		},
	);

	return starterExperienceDashboardSunriseV1;
}

export async function isSunriseDashboardPageAccessExperimentEnabled(utilityContext: UtilityContext) {
	const experiment = await queryExperiment(utilityContext);

	return experiment.variation !== 'control';
}
